function About() {
  return (
    <section className="about" id="about">
      <div className="container about-content">
        <div className="about-visual" aria-hidden="true">
          <div className="about-shape about-shape-one">🧮</div>
          <div className="about-shape about-shape-two">🧘</div>
          <div className="about-center">
            <span>🌱</span>
            <strong>Growing the whole child</strong>
            <small>Knowledge • Confidence • Values</small>
          </div>
        </div>

        <div className="about-text">
          <span className="eyebrow">Our philosophy</span>
          <h2>Ancient wisdom. Modern learning. One bright future.</h2>
          <p>
            We are an online learning platform dedicated to education that goes
            beyond academics. Our programs combine proven traditional practices
            with engaging teaching methods to nurture curious, capable minds.
          </p>
          <p>
            Based in Hyderabad and serving learners globally, our experienced
            instructors offer flexible schedules, personal guidance and a warm,
            encouraging learning environment.
          </p>
          <div className="about-points">
            <span>✓ Live interactive learning</span>
            <span>✓ Personal mentor attention</span>
            <span>✓ Skills for school and life</span>
          </div>
          <a href="#contact" className="text-link">Begin the journey <span>→</span></a>
        </div>
      </div>
    </section>
  );
}

export default About;
